import React,{useState,useEffect} from "react"
import {Modal,ModalBody,ModalHeader,ModalFooter} from "reactstrap"
import ImageEditor, { ARTICLE } from "./ImageEditor";
import Api from "./Api";
import { useGlobal } from "./Reducer";
import { Editor } from '@tinymce/tinymce-react';
//uwbb317anxcfxvyl3caq2c45ffv4bm42xw2noh57089qqqnq


export default (props)=>{

    const [gs,ga] =useGlobal();
    const article=props.article||{id:0};
    const [showImageSel,setShowImageSel]=useState(false);
    const [title,setTitle]=useState(article.title);
    const [intro,setIntro]=useState(article.intro);
   // debugger;
    const [byLine,setByLine]=useState(article.byline);
    const [body,setBody]=useState(article.body);
    const [image,setImage]=useState(article.image);


    const save=()=>{
        ga.loading(true);
        Api.saveArticle(title,intro,byLine,body,image,article.id).then(()=>{
            props.onClose();
        }).catch(err=>{
            alert(err);
        }).finally(()=>{
            ga.loading(false);
        });


    }



    return (<Modal size={"xl"} isOpen={true}>


{showImageSel && <ImageEditor onClose={()=>setShowImageSel(false)}
                    withImage={(image)=>setImage(image)}
            type={ARTICLE}/>}
                <ModalHeader>
                    Select Article
                </ModalHeader>
                <ModalBody>
                <div className="form-group">
                        <label>Title</label>
                        <input value={title}
                            onChange={e=>setTitle(e.target.value)}
                        type="text" className="form-control"></input>
                    </div>
                    <div className="form-group">
                        <label>By Line</label>
                        <input 
                        value={byLine}
                        onChange={e=>setByLine(e.target.value)} type="text" className="form-control"></input>
                    </div>
                    <div className="form-group">
                        <label>Intro</label>
                        <Editor
                         value={intro||''}
                         initialValue={intro||''}
                         onEditorChange={e=>setIntro(e)}
                        
                        apiKey='uwbb317anxcfxvyl3caq2c45ffv4bm42xw2noh57089qqqnq' init={{  

                            force_br_newlines: false,
                            force_p_newlines: false,
                             forced_root_block: false,
                             force_p_newlines:true,
                            
                            menubar: 'edit insert view format table tools help',
                            height: 200,
                            plugins: [
                                "paste textcolor link table code"
                            ],
                            toolbar1: "  bold italic underline strikethrough | alignleft aligncenter alignright alignjustify |    fontsizeselect",
                            toolbar2: "cut copy paste | searchreplace | bullist numlist | outdent indent blockquote | undo redo | link unlink | insertdatetime preview | forecolor backcolor",
                            toolbar_items_size: 'small',
                            fontsize_formats: '10pt 11pt 12pt 13pt 14pt 15pt 16pt 17pt 18pt 24pt 36pt',
                            font_formats: 'Arial=arial,helvetica,sans-serif;FrutigerLTStd-Black=FrutigerLTStd-BlackFrutigerLTStd-BlackCn=FrutigerLTStd-BlackCn;FrutigerLTStd-BlackItalic=FrutigerLTStd-BlackItalic;FrutigerLTStd-Bold=FrutigerLTStd-Bold;FrutigerLTStd-BoldCn=FrutigerLTStd-BoldCn;FrutigerLTStd-BoldItalic=FrutigerLTStd-BoldItalic;FrutigerLTStd-Cn=FrutigerLTStd-Cn;FrutigerLTStd-ExtraBlackCn=FrutigerLTStd-ExtraBlackCn;FrutigerLTStd-Italic=FrutigerLTStd-Italic;FrutigerLTStd-Light=FrutigerLTStd-Light;FrutigerLTStd-LightCn=FrutigerLTStd-LightCn;FrutigerLTStd-LightItalic=FrutigerLTStd-LightItalic;FrutigerLTStd-Roman=FrutigerLTStd-Roman;FrutigerLTStd-UltraBlack=FrutigerLTStd-UltraBlack',
                            content_css: [
                                '../assets/css/font_arial.css'
                    
                            ]

                         }} />

                       
                    </div>
                    <div className="form-group">
                        <label>Body</label>
                        <Editor
                        initialValue={body||''}
                         value={body||''}
                         onEditorChange={e=>setBody(e)}
                        
                        apiKey='uwbb317anxcfxvyl3caq2c45ffv4bm42xw2noh57089qqqnq' init={
                            {
                                force_br_newlines: false,
                                force_p_newlines: false,
                                forced_root_block: false,
                                
                                menubar: 'edit insert view format table tools help',
                                height: 300,
                                plugins: [
                                    "paste textcolor link table code"
                                ],
                        
                                // paste_retain_style_properties:"all",
                                toolbar1: "  bold italic underline strikethrough | alignleft aligncenter alignright alignjustify |    fontsizeselect",
                                toolbar2: "cut copy paste | searchreplace | bullist numlist | outdent indent blockquote | undo redo | link unlink | insertdatetime preview | forecolor backcolor",
                        
                                toolbar_items_size: 'small',
                                fontsize_formats: '10pt 11pt 12pt 13pt 14pt 15pt 16pt 17pt 18pt 24pt 36pt',
                                font_formats: 'Arial=arial,helvetica,sans-serif;FrutigerLTStd-Black=FrutigerLTStd-BlackFrutigerLTStd-BlackCn=FrutigerLTStd-BlackCn;FrutigerLTStd-BlackItalic=FrutigerLTStd-BlackItalic;FrutigerLTStd-Bold=FrutigerLTStd-Bold;FrutigerLTStd-BoldCn=FrutigerLTStd-BoldCn;FrutigerLTStd-BoldItalic=FrutigerLTStd-BoldItalic;FrutigerLTStd-Cn=FrutigerLTStd-Cn;FrutigerLTStd-ExtraBlackCn=FrutigerLTStd-ExtraBlackCn;FrutigerLTStd-Italic=FrutigerLTStd-Italic;FrutigerLTStd-Light=FrutigerLTStd-Light;FrutigerLTStd-LightCn=FrutigerLTStd-LightCn;FrutigerLTStd-LightItalic=FrutigerLTStd-LightItalic;FrutigerLTStd-Roman=FrutigerLTStd-Roman;FrutigerLTStd-UltraBlack=FrutigerLTStd-UltraBlack',
                                content_css: [
                                    '../assets/css/font_arial.css'
                        
                                ]
                            }
                            
                            } />


                       
                    </div>
                    <div className="form-group">
                        <label>Image</label>
                       <div style={{margin:10}}>
                            <img src={image} style={{maxHeight:200,maxWidth:200}} />

                       </div>
                       <button
                        onClick={()=>{
                            setShowImageSel(true)
                        }}
                       className="btn btn-success">Select</button>

<button
                        onClick={()=>{
                           setImage(null);
                        }}
                       className="btn btn-danger">Remove</button>


                    </div>


                    
                    
                

                </ModalBody>
                <ModalFooter>
                <button onClick={()=>save()} className="btn btn-success">Save</button>
                    <button onClick={()=>props.onClose()} className="btn btn-secondary">Close</button>
                </ModalFooter>

    </Modal>);
}